import { manageBannerClass } from 'views/assets/scripts/stickyBanner'
import { SPA_CART } from 'views/consts'

export default () => {
  const cartStickyCta = document.querySelector<HTMLElement>(
    '[data-clientside-hook="sticky-cta"]'
  )

  const showStickyCta = () => {
    cartStickyCta?.classList.remove('u-hidden')
    manageBannerClass()
  }

  const hideStickyCta = () => {
    cartStickyCta?.classList.add('u-hidden')
    manageBannerClass()
  }

  const spaCart = document.getElementById(SPA_CART)
  if (spaCart) {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        hideStickyCta()
      } else {
        showStickyCta()
      }
    })
    observer.observe(spaCart)
  }
}
